export enum TicketStatus {    
    Open = 1,
    Pending = 2,
    Closed = 3,
    Resolved = 4,
    Reopened = 5
}